import { Box, useTheme } from '@mui/material';
import { grey } from '@mui/material/colors';
import React from 'react';

const StyledItem: React.FC<React.ComponentProps<typeof Box>> = (props) => {
	const theme = useTheme();

	const dotsColor = theme.palette.text.disabled;
	const dotSize = 3;
	const verticalSpace = dotSize * 1.7;
	const horizontalSpace = dotSize * 1.7;

	const sixDotsStyle = {
		backgroundColor: 'transparent',
		borderRadius: '50%',
		content: '""',
		position: 'absolute',
		width: `${dotSize}px`,
		height: `${dotSize}px`,
		top: '50%',
		right: '5px',
		transform: 'translateY(-50%)',
		boxShadow:
			`${-dotSize - horizontalSpace}px ${-verticalSpace}px 0 0 ${dotsColor},` + // top left
			`${-dotSize - horizontalSpace}px 0px 0 0 ${dotsColor},` + // center left
			`${-dotSize - horizontalSpace}px ${verticalSpace}px 0 0 ${dotsColor},` + // bottom left
			`${-dotSize}px ${-verticalSpace}px 0 0 ${dotsColor},` + // top right
			`${-dotSize}px 0px 0 0 ${dotsColor},` + // center right
			`${-dotSize}px ${verticalSpace}px 0 0 ${dotsColor}` // bottom right
	};
	return (
		<Box
			{...props}
			width="100%"
			display="flex"
			alignItems="center"
			sx={{
				position: 'relative',
				backgroundColor: theme.palette.mode === 'dark' ? grey[800] : grey[200],
				borderRadius: 2,
				paddingX: 1,
				paddingY: 1,
				paddingRight: 3,
				'&:hover&:after': sixDotsStyle
			}}
		/>
	);
};

export default StyledItem;
